'use strict';

/**
 * @ngdoc service
 * @name courseApp.Auth
 * @description
 * # Auth
 * Factory in the courseApp.
 */
angular.module('courseApp')
    .factory('Auth', function (BasicService, authService, CONFIG) {
        return {
            login: function (userData) {
                return BasicService.http({
                    method: 'POST',
                    data: userData,
                    url: CONFIG.authURL,
                    cache: false
                }).then(function (response) {
                    var userResponse = { username: response.config.data.username, token: response.data.token };
                    authService.loginConfirmed(userResponse);
                });
            },
            logout: function () {
                BasicService.cookies.remove('djangotoken');
                BasicService.cookies.remove('djangouser');
                BasicService.http.defaults.headers.common.Authorization = undefined;
                authService.loginCancelled();
                BasicService.location.path('/');
            },
            isLoggedIn: function () {
                if (BasicService.cookies.get('djangotoken')) {
                    return true;
                }
                return false;
            }
        };
    });
